export const COMPANY = {
  name: "Kodenzo Labs",
  email: "info@kodenzolabs.in",
  phone: "+91 80 0000 0000",
  address: "New Delhi, India",
  founded: "2019",
  socials: {
    linkedin: "https://www.linkedin.com/company/kodenzolabs",
    twitter: "https://twitter.com/kodenzolabs",
    instagram: "https://instagram.com/kodenzolabs",
  },
  stats: [
    { value: "180+", label: "Engineers & Designers" },
    { value: "240+", label: "Products Shipped" },
    { value: "32", label: "Countries Served" },
    { value: "98%", label: "Client Retention" },
  ],
  leadership: [
    { name: "Aarav Mehta", role: "Founder & CEO", bio: "Ex-AWS Principal Engineer. Built infra for three exits. Believes great companies are built by great engineers.", image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
    { name: "Devansh Kapoor", role: "CTO", bio: "Distinguished Engineer with 20 years across Google, Stripe and two startups. Distributed systems generalist.", image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
    { name: "Priya Nair", role: "Head of AI", bio: "Former DeepMind research engineer. Leads our AI platform, MLOps and production RAG systems.", image: "https://images.pexels.com/photos/6805161/pexels-photo-6805161.jpeg?w=600" },
    { name: "Rohit Iyer", role: "Head of Design", bio: "Built design systems at Razorpay and Notion. Believes great design is invisible until it is missed.", image: "https://images.pexels.com/photos/6804068/pexels-photo-6804068.jpeg?w=600" },
  ],
};
